import { Tab } from "@headlessui/react";
import CarCard from "components/CarCard/CarCard";
import CommentListing from "components/CommentListing/CommentListing";
import ExperiencesCard from "components/ExperiencesCard/ExperiencesCard";
import StartRating from "components/StartRating/StartRating";
import BrandCard from "components/BrandCard/StayCard";
import SectionDetails from './SectionDetails';
import {
  DEMO_CAR_LISTINGS,
  DEMO_EXPERIENCES_LISTINGS,
  DEMO_STAY_LISTINGS,
} from "data/listings";
import React, { FC, Fragment, useEffect, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import SocialsList from "shared/SocialsList/SocialsList";
import SectionAttachImages from './SectionAtttachImages';
import { Helmet } from "react-helmet-async";
import { connect, useDispatch } from "react-redux";
import { deleteAgencyImage, deleteAgencyVideo, deleteBrand, logout, updateUser, deleteBrandVideo, deleteBrandImage } from "../../redux/reducers/userReducer";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import api from '../../api';
import AvailabilitySection from "./AvailabilitySection";
import ContactInformationSection from "./ContactInformationSection";
import AboutSection from "./AboutSection";
import MarketSection from "./MarketSection";
import HowYouWorkSection from "./HowYouWorkSection";
import BrandExperienceSection from "./BrandExperienceSection";
import SalesDetailSection from "./SalesDetailSection";
import MediaSection from "./MediaSection";
import ImageLightbox from "components/ImageLightbox/ImageLightbox";
import VideoUploader from "./VideoUploader";
import SecuritySection from "./SecuritySection";
import UserDetailsSection from "./UserDetailsSection";
import { Badge } from "@mui/material";
import Button from "../../shared/Button/Button";
import AgencyImages from "./AgencyImages";
import DeleteConfirmationModal from "components/DeletModal/DeleteConfirmationModal";
import BrandBasicInfoSection from './BrandBasicInfoSection';
import BrandSalesInfoSection from './BrandSalesInfoSection';
import BrandDnaSection from './BrandDnaSection';
import BrandAgentRequiremntSection from './BrandAgentRequiremntSection';
import BrandMediaSection from './BrandMediaSection';

const AgencyTabs = [
  "About",
  "Details",
  "How You Work",
  "Markets",
  "Brand Experience",
  "Availability",
  "Media",
  // "Contact",
];
const BrandTabs = [
  "Brands",
  "Details",
  // "Markets",
];

const BrandSettingTabs = [
  { title: "Basic Info", keyItem: 'brand-basic-info' },
  { title: "Sales Info", keyItem: 'brand-sales-info' },
  { title: "Brand DNA", keyItem: 'brand-dna' },
  { title: "Agent Requirements", keyItem: 'brand-agent-requirements' },
  { title: "Media", keyItem: 'brand-media' }
]

const PageAccount = ({ className, user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams?.get("page");
  const shortnameParam = searchParams?.get("name");

  const onBrandCreate = () => {
    navigate('/create-brand');
  };

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<{ id: number, type: 'image' | 'video' } | null>(null);
  const [activeTab, setActiveTab] = useState(() => {
    if (location.state?.activeTab) {
      return location.state.activeTab;
    }
    if (location.state?.fromCreateBrand && user?.company_type === 'brandowners') {
      return 'brands';
    }
    return 'business-details';
  });
  const [currentImage, setCurrentImage] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [brandToDelete, setBrandToDelete] = useState(null);
  const [deleteBrandModalOpen, setDeleteBrandModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const inBrandSettings = BrandSettingTabs.find(item => item.keyItem === page);
    const redirectBrand = user?.company?.brands?.find(item => item.shortname === shortnameParam);

    // Update user company data after brand creation
    if(location.state?.fromCreateBrand){
        api.getUserCompanies({id: user.id}, (res2) => {
          const company = res2.data && res2.data.length > 0 ? res2.data[0] : null;
          api.getCompanyType(user.id, () => {
            dispatch(updateUser({
              company: company,
            }));            
          }, (companyTypeError) => {
            dispatch(updateUser({
              company: company,
              company_type: company?.type || null,
            }));
          });
        });
    }

    if (page && inBrandSettings && user?.company_type === 'brandowners' && user?.company?.id === redirectBrand?.brandowner_id) {
      setTimeout(() => {
        setSelectedBrand(redirectBrand);
        setActiveTab(page);
      }, 100);
    } else if (page && !inBrandSettings && user?.company_type === 'agencies') {
      setTimeout(() => {
        setActiveTab(page);
      }, 100);
    } else if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
      window.history.replaceState({}, document.title);
    } else if (location.state?.fromCreateBrand && user?.company_type === 'brandowners') {
      setActiveTab('brands');
      window.history.replaceState({}, document.title);
    }

  }, [location.state, user?.company_type]);

  // Initialize selected brand when component mounts or user changes
  useEffect(() => {
    if (user?.company?.brands?.length > 0 && !selectedBrand) {
      setSelectedBrand(user.company.brands[0]);
    }
  }, [user, selectedBrand]);


  useEffect(() => {
    if (selectedBrand) {
      setSelectedBrand(user.company.brands.find(item => item.id === selectedBrand.id));
    }
  }, [user, user.company, user.company.brands]);

  const formatTabName = (tabKey) => {
    const tabNames = {
      'media': 'Media',
      'business-details': 'Business Details',
      'user-details': 'User Details',
      'security': 'Security',
      'brands': 'Brands',
      'availability': 'Availability',
      'contact': 'Contact Information',
      'about': 'About',
      'markets': 'Markets',
      'how-you-work': 'How You Work',
      'brand-experience': 'Brand Experience',
      'sales-details': 'Sales Details',
      'brand-basic-info': 'Brand Basic Info',
      'brand-sales-info': "Brand Sales Info",
      'brand-dna': "Brand DNA",
      'brand-agent-requirements': "Brand Agent Requirements",
      'brand-media': "Brand Media",
    };

    return tabNames[tabKey] || 'Account';
  };

  const hasEmptyFields = (section) => {
    const checkMap = {
      'media': () => {
        const hasImages = user?.company?.media?.length > 0 || user?.company?.images?.length > 0;
        const hasVideo = user?.company?.showroom_video?.url;
        return !hasImages && !hasVideo;
      },
      'details': () => !user?.company?.name || !user?.company?.description,
      'availability': () => !user?.company?.availability_status,
      'about': () => {
        const about = user?.company?.about || {};
        return (
          !about.languages || about.languages.length === 0 ||
          !about.availability ||
          !user?.company?.showrooms || user.company.showrooms.length === 0 ||
          !about.about_agency ||
          !about.industry_expertise ||
          !about.industry_experience ||
          !about.number_of_agents ||
          !user?.company?.vg_brand_partnership ||
          !user?.company?.vg_sales ||
          !user?.company?.vg_strengths
        );
      },
      'markets': () => !user?.company?.market?.product_categories?.length,
      'how-you-work': () => !user?.company?.b2b_size || !user?.company?.sales_strat,
      'brand-experience': () => {
        const experience = user?.company?.brand_experience;
        return !experience?.current_brands?.length ||
          !experience?.past_brands?.length || experience?.current_brands?.some(brand => !brand.name ||
            !brand.achievements || !brand.sales?.num_dealers ||
            !brand.sales?.price_range) || experience?.past_brands?.some(brand => !brand.name ||
              !brand.achievements || !brand.sales?.num_dealers || !brand.sales?.price_range);
      },
      'brand-basic-info': () => {
        return [
          selectedBrand?.name,
          selectedBrand?.description,
          selectedBrand?.country?.length > 0,
          selectedBrand?.contact_person_name,
          selectedBrand?.contact_person_email,
          selectedBrand?.contact_person_phone,
        ].some(field => !field);
      },
      'brand-sales-info': () => {
        return [
          selectedBrand?.market?.product_categories?.length > 0,
          selectedBrand?.regions?.length > 0,
        ].some(field => !field);
      },
      'brand-agent-requirements': () => {
        return [
          selectedBrand?.agent_regions?.length > 0,
          selectedBrand?.agent_representation ? selectedBrand?.agent_rep_regions?.length > 0 : true,
        ].some(field => !field);
      },
      'brand-media': () => {
        return [
          selectedBrand?.images?.length > 0,
          selectedBrand?.showroom_video?.url,
        ].some(field => !field);
      },
    };

    const key = section.toLowerCase().replace(/ /g, '-');
    return checkMap[key]?.() ?? false;
  };

  const [lightboxState, setLightboxState] = useState({
    open: false,
    imageUrl: "",
  });

  const handleOpenLightbox = (imageUrl: string) => {
    setLightboxState({ open: true, imageUrl });
  };

  const handleCloseLightbox = () => {
    setLightboxState({ open: false, imageUrl: "" });
  };

  const setParentImage = (image) => {
    setCurrentImage(image);
  };

  const handleDeleteBrand = (brandId) => {
    setBrandToDelete(brandId);
    setDeleteBrandModalOpen(true);
  };

  const confirmDeleteBrand = () => {
    if (!brandToDelete || isDeleting) return;

    setIsDeleting(true);
    api.deleteBrand(
      brandToDelete,
      (response) => {
        dispatch(deleteBrand(brandToDelete));
        if (selectedBrand?.id === brandToDelete) {
          const remainingBrands = user?.company?.brands?.filter(brand => brand.id !== brandToDelete);
          setSelectedBrand(remainingBrands?.length > 0 ? remainingBrands[0] : null);
        }
        setDeleteBrandModalOpen(false);
        setBrandToDelete(null);
        setIsDeleting(false);
      },
      (error) => {
        setIsDeleting(false);
      }
    );
  };

  const cancelDeleteBrand = () => {
    console.log('Delete cancelled');
    setDeleteBrandModalOpen(false);
    setBrandToDelete(null);
  };

  const openDeleteModal = (id: number, type: 'image' | 'video') => {
    setItemToDelete({ id, type });
    setDeleteModalOpen(true);
  };

  const confirmDeleteAttachment = () => {
    if (itemToDelete) {
      api.deleteAttachment(
        itemToDelete.id,
        (res) => {
          if (res.data.key === 'showroom_video') {
            if (user?.company_type === 'agencies') {
              dispatch(deleteAgencyVideo());
            } else {
              dispatch(deleteBrandVideo(res.data));
            }

          } else {
            if (user?.company_type === 'agencies') {
              dispatch(deleteAgencyImage({ id: res.data.id }));
            } else {
              dispatch(deleteBrandImage(res.data));
            }
          }
          setDeleteModalOpen(false);
        }
      );
    }
  };

  const avatarUrl = user?.avatar
    ? `${api.getUploadUrl()}/${user.avatar}`
    : user?.company?.avatar
      ? `${api.getUploadUrl()}/${user.company.avatar.url}`
      : null;

  const handleBrandSelect = (brand) => {
    setSelectedBrand(brand);
    setActiveTab('brand-basic-info');
  };

  const renderSidebar = () => {
    const tabs = user?.company_type === 'agencies' ? AgencyTabs : BrandTabs;

    return (
      <div className="w-full flex flex-col items-center text-left sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8">
        <div onClick={() => avatarUrl && handleOpenLightbox(avatarUrl)} className="cursor-pointer">
          <Avatar
            hasChecked
            hasCheckedClass="w-6 h-6 -top-0.5 right-2"
            sizeClass="w-28 h-28"
            imgUrl={avatarUrl}
            userName={(user?.name || " ")}
          />
        </div>

        <div className="space-y-3 text-center flex flex-col items-center">
          <h2 className="text-xl font-semibold">{user?.name}</h2>
        </div>

        <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>

        <div className="w-full">
          <span className="text-neutral-800 dark:text-neutral-300 block mb-3">User Settings</span>
          <div className="flex flex-col space-y-2">
            {["Details", "Security"].map((tab) => {
              const tabKey = tab.toLowerCase() === "details" ? "user-details" : tab.toLowerCase();
              return (
                <a
                  key={tab}
                  href={`#${tabKey}`}
                  className={`text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-md px-3 py-2 capitalize ${activeTab === tabKey ? "bg-neutral-200 dark:bg-neutral-700" : ""
                    }`}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab(tabKey);
                    document.getElementById(tabKey)?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  {tab}
                </a>
              );
            })}
          </div>
        </div>


        {/* ---- */}
        <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>

        <div className="w-full">
          <span className="text-neutral-800 dark:text-neutral-300 block mb-3">Business Settings</span>
          <div className="flex flex-col space-y-2">
            {tabs.map((item) => {
              const itemKey =
                item.toLowerCase() === "details"
                  ? "business-details"
                  : item.toLowerCase().replace(/ /g, "-");
              return (
                <a
                  key={item}
                  href={`#${itemKey}`}
                  className={`text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-md px-3 py-2 capitalize ${activeTab === itemKey ? "bg-neutral-200 dark:bg-neutral-700" : ""
                    }`}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab(itemKey);
                    document.getElementById(itemKey)?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  {hasEmptyFields(item) ? (
                    <Badge color="error" variant="dot">
                      <span>{item}</span>
                    </Badge>
                  ) : (
                    <span>{item}</span>
                  )}
                </a>
              );
            })}
            {/* {
              user?.company_type == 'agencies' &&
              <a
                href={`${window.location.origin}/agency/${user?.company?.shortname}`}
                target='_blank'
                className={`text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-md px-3 py-2 capitalize`}
              >
                View Agency Profile
              </a>
            } */}
          </div>
        </div>

        {user?.company_type === 'brandowners' && user?.company?.brands?.length > 0 && (
          <>
            {/* ---- */}
            <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>

            <div className="w-full">
              <span className="text-neutral-800 dark:text-neutral-300 block mb-3">Brand Settings</span>
              <div className="flex flex-col space-y-2">
                {/* Brand Profile Dropdown - only show for brand owners */}

                <div className="mb-3">
                  <label className="block text-xs text-neutral-600 dark:text-neutral-400 mb-1">
                    Select Brand Profile
                  </label>
                  <select
                    value={selectedBrand?.id || ''}
                    onChange={(e) => {
                      const brand = user.company.brands.find(b => b.id === parseInt(e.target.value));
                      handleBrandSelect(brand);
                    }}
                    className="w-full px-2 py-1 text-sm border border-neutral-300 dark:border-neutral-600 rounded bg-white dark:bg-neutral-800 text-neutral-700 dark:text-neutral-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  >
                    {user.company.brands.map((brand) => (
                      <option key={brand.id} value={brand.id}>
                        {brand.name}
                      </option>
                    ))}
                  </select>
                </div>

                {selectedBrand && BrandSettingTabs.map(({ title, keyItem }) => {
                  return (
                    <a
                      key={keyItem}
                      href={`#${keyItem}`}
                      className={`text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-md px-3 py-2 capitalize ${activeTab === keyItem ? "bg-neutral-200 dark:bg-neutral-700" : ""
                        }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab(keyItem);
                        document.getElementById(keyItem)?.scrollIntoView({ behavior: "smooth" });
                      }}
                    >
                      {hasEmptyFields(keyItem) ? (
                        <Badge color="error" variant="dot">
                          <span>{title}</span>
                        </Badge>
                      ) : (
                        <span>{title}</span>
                      )}
                    </a>
                  );
                })}
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap">
        {activeTab === 'brands' && user?.company_type === 'brandowners' && (
          <div id="brands">
            <button
              style={{ marginLeft: 4, borderRadius: '5px', margin: '20px 12px' }}
              onClick={onBrandCreate}
            >
              Create Brand Profile
            </button>
            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3">
              {user?.company?.brands?.map((brand) => {
                const tempGalleryImgs = (brand?.images).map((b) => `${api.getUploadUrl()}/${b.url}`);
                let brandData = {
                  galleryImgs: tempGalleryImgs?.length > 0 ? tempGalleryImgs : [`${api.getUploadUrl()}/noImage`],
                  title: brand.name,
                  href: `/brand/${brand.shortname}`,
                };
                return (
                  <BrandCard
                    key={brand.id}
                    data={brandData}
                    showDelete={true}
                    onDelete={() => handleDeleteBrand(brand.id)}
                    size="small"
                  />
                );
              })}
            </div>
          </div>
        )}

        {activeTab === 'user-details' && (
          <div id="user-details">
            <UserDetailsSection />
          </div>
        )}

        {activeTab === 'security' && (
          <div id="security">
            <SecuritySection />
          </div>
        )}

        {activeTab === 'business-details' && (
          <div id="business-details">
            <SectionDetails />
          </div>
        )}

        {activeTab === 'media' && (
          <MediaSection
            user={user}
            entity={user?.company_type == 'agencies' ? 'agencies' : 'brandowners'}
            entity_id={user?.company?.id}
            openDeleteModal={openDeleteModal}
          />
        )}

        {activeTab === 'availability' && (
          <div id="availability">
            <AvailabilitySection />
          </div>
        )}

        {activeTab === 'contact' && (
          <div id="contact">
            <ContactInformationSection />
          </div>
        )}

        {activeTab === 'about' && (
          <div id="about">
            <AboutSection />
          </div>
        )}

        {activeTab === 'markets' && (
          <div id="markets">
            <MarketSection selectedBrand={selectedBrand} />
          </div>
        )}

        {activeTab === 'how-you-work' && (
          <div id="how-you-work">
            <HowYouWorkSection />
          </div>
        )}

        {activeTab === 'brand-experience' && (
          <div id="brand-experience">
            <BrandExperienceSection />
          </div>
        )}

        {activeTab === 'sales-details' && (
          <div id="sales-details">
            <SalesDetailSection />
          </div>
        )}

        {activeTab === 'brand-basic-info' && (
          <div id="brand-basic-info">
            <BrandBasicInfoSection selectedBrand={selectedBrand} />
          </div>
        )}

        {activeTab === 'brand-sales-info' && (
          <div id="brand-sales-info">
            <BrandSalesInfoSection selectedBrand={selectedBrand} />
          </div>
        )}

        {activeTab === 'brand-dna' && (
          <div id="brand-dna">
            <BrandDnaSection selectedBrand={selectedBrand} />
          </div>
        )}

        {activeTab === 'brand-agent-requirements' && (
          <div id="brand-agent-requirements">
            <BrandAgentRequiremntSection selectedBrand={selectedBrand} />
          </div>
        )}

        {activeTab === 'brand-media' && (
          <div id="brand-media">
            <BrandMediaSection
              openDeleteModal={openDeleteModal}
              selectedBrand={selectedBrand}
            />
          </div>
        )}

      </div>
    );
  };

  return (
    <div className={`nc-AuthorPage ${className}`} data-nc-id="AuthorPage">
      <Helmet>
        <title>Agent Match | {formatTabName(activeTab)}</title>
      </Helmet>
      <main className="container mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
        <div className="w-full lg:w-1/4 mb-24 lg:mb-0">
          <div className="lg:sticky lg:top-24">{renderSidebar()}</div>
        </div>
        <div className="w-full lg:w-3/4 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
          {renderSection1()}
          {/* {renderSection2()} */}
        </div>
      </main>
      <ImageLightbox
        open={lightboxState.open}
        imageUrl={lightboxState.imageUrl}
        onClose={handleCloseLightbox}
      />
      {/* Add the delete confirmation modal */}
      <DeleteConfirmationModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={confirmDeleteAttachment}
        itemType={itemToDelete?.type || 'image'}
      />

      {/* Brand profile delete confirmation modal */}
      <DeleteConfirmationModal
        isOpen={deleteBrandModalOpen}
        onClose={cancelDeleteBrand}
        onConfirm={confirmDeleteBrand}
        itemType="brand"
        title="Delete Brand Profile"
        message="Are you sure you want to delete this brand profile? This action cannot be undone."
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(
  mapStateToProps,
  {
    updateUser,
    deleteAgencyImage,
    deleteAgencyVideo,
    deleteBrand,
    logout,
    deleteBrandVideo,
    deleteBrandImage,
  }
)(PageAccount);